import { Injectable } from '@angular/core';

import { Models } from '@ibexfusion/models';
import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class CompositionService extends RestfulService<Models.Composition> {

  constructor(private restService: RestService) {
    super(Models.Composition);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('compositions');
  }

}
